import ErrorBoundary from 'signer-app/parts/error-boundary/error-boundary';
import { RouteBoundary } from 'signer-app/parts/error-boundary/route-boundary';
import { useCatchError } from 'signer-app/utils/use-catch-error';

export default ErrorBoundary;

export { RouteBoundary, useCatchError };
